<template>
  <div class="report-container">
    <div class="page-header no-print">
      <div class="breadcrumb">ລາຍງານ / <span>ນັກສຶກສາທີ່ກຳລັງສຶກສາຢູ່</span></div>
      <div class="header-content-wrapper">
        <div>
          <h1>ບົດລາຍງານນັກສຶກສາຮຽນຕ່າງປະເທດ ທີ່ຍັງກຳລັງສຶກສາຢູ່</h1>
          <p>ສະຫຼຸບແຍກຕາມປະເທດ</p>
        </div>
        <div class="header-actions">
          <button class="btn-print" @click="printReport" :disabled="loading">
            <i class="fas fa-print"></i> ພິມລາຍງານ
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="state-panel no-print"><i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດຂໍ້ມູນ...</div>

    <div v-else class="report-content-paper">
      <div class="report-header-print only-print">
        <h2>ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</h2>
        <h3>ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນະຖາວອນ</h3>
        <div class="report-title-section">
          <h4>ບົດລາຍງານນັກສຶກສາຮຽນຕ່າງປະເທດ ທີ່ຍັງກຳລັງສຶກສາຢູ່ (ແຍກຕາມປະເທດ)</h4>
          <p>ພິມວັນທີ: {{ todayFormatted }}</p>
        </div>
      </div>

      <div class="kpi-grid mb-4">
        <div class="kpi-card border">
          <div class="kpi-label">ນັກສຶກສາທັງໝົດທີ່ກຳລັງສຶກສາຢູ່</div>
          <div class="kpi-value text-primary">{{ summary.totalStudents }}</div>
        </div>
        <div class="kpi-card border">
          <div class="kpi-label">ຈຳນວນປະເທດ</div>
          <div class="kpi-value text-success">{{ summary.totalCountries }}</div>
        </div>
      </div>

      <div v-if="countries.length === 0" class="empty-state">ບໍ່ມີຂໍ້ມູນນັກສຶກສາທີ່ກຳລັງສຶກສາຢູ່</div>

      <div v-for="grp in countries" :key="grp.country" class="panel mb-4">
        <div class="panel-head">
          <h3><i class="fas fa-flag mr-2"></i> {{ grp.country }} <span class="count-pill">{{ grp.count }} ຄົນ</span></h3>
        </div>
        <div class="panel-body">
          <table class="report-table">
            <thead>
              <tr>
                <th>ລຳດັບ</th>
                <th>ລະຫັດນັກສຶກສາ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ເພດ</th>
                <th>ລະດັບການສຶກສາ</th>
                <th>ສາຂາວິຊາ</th>
                <th>ສະຖາບັນການສຶກສາ</th>
                <th>ສົກຮຽນເລີ່ມຕົ້ນ</th>
                <th>ຄາດວ່າຈະຈົບ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in grp.students" :key="s._id">
                <td>{{ i + 1 }}</td>
                <td>{{ s.student_code }}</td>
                <td class="text-left">{{ s.full_name_lao }}</td>
                <td>{{ s.gender }}</td>
                <td>{{ s.degree_level }}</td>
                <td>{{ s.field_of_study }}</td>
                <td class="text-left">{{ s.university_name || '-' }}</td>
                <td>{{ s.academic_year_start || '-' }}</td>
                <td>{{ s.expected_graduation || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'OverseaActiveReportPage',
  data() {
    return {
      loading: false,
      user: {},
      summary: { totalStudents: 0, totalCountries: 0 },
      countries: []
    };
  },
  computed: {
    consulateCountry() {
      return this.user.org_role === 'consulate' ? (this.user.country || null) : null;
    },
    todayFormatted() {
      return new Date().toLocaleDateString('lo-LA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
  },
  mounted() {
    this.loadUserInfo();
    this.fetchReportData();
  },
  methods: {
    loadUserInfo() {
      const savedInfo = localStorage.getItem('user-info');
      if (savedInfo) {
        try { this.user = JSON.parse(savedInfo); } catch (e) { this.user = {}; }
      }
    },
    async fetchReportData() {
      this.loading = true;
      try {
        const res = await api.get('/reports/oversea-active-by-country', {
          params: { host_country: this.consulateCountry }
        });
        if (res.data.code === 1) {
          this.summary = res.data.data.summary;
          this.countries = res.data.data.countries;
        }
      } catch (e) {
        console.error('Fetch active report error:', e);
      } finally {
        this.loading = false;
      }
    },
    printReport() {
      window.print();
    }
  }
};
</script>

<style scoped>
.report-container { padding: 20px; animation: fadeIn 0.4s ease; }
.header-content-wrapper { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.btn-print { background: var(--lao); color: white; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 600; }
.btn-print:disabled { opacity: 0.6; cursor: not-allowed; }

.state-panel { background: var(--card); border: 1px solid var(--border); border-radius: 10px; padding: 60px 20px; text-align: center; color: var(--text3); }
.empty-state { text-align: center; color: var(--text3); padding: 30px; }

.kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; }
.kpi-card { background: var(--card); border-radius: 10px; padding: 18px 20px; }
.kpi-card.border { border: 1px solid var(--border); }
.kpi-label { font-size: 12.5px; color: var(--text3); margin-bottom: 6px; }
.kpi-value { font-size: 28px; font-weight: 700; }
.text-primary { color: var(--lao); }
.text-success { color: var(--success); }

.panel-head h3 { display: flex; align-items: center; font-size: 14px; }
.count-pill { margin-left: 10px; background: var(--lao-light); color: var(--lao); font-size: 11.5px; padding: 2px 10px; border-radius: 12px; font-weight: 600; }

.report-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
.report-table th, .report-table td { border: 1px solid #e2e8f0; padding: 10px; text-align: center; font-size: 12.5px; }
.report-table th { background: #f8fafc; color: #475569; font-weight: 700; }
.text-left { text-align: left; }

.report-header-print { text-align: center; margin-bottom: 30px; }
.report-title-section { margin-top: 20px; border-top: 2px solid #000; padding-top: 10px; }
.only-print { display: none; }

@media print {
  .no-print { display: none !important; }
  .only-print { display: block !important; }
  .report-container { padding: 0; }
  .panel { border: none !important; box-shadow: none !important; }
  body { background: white; }
  .report-table th { background: #eee !important; -webkit-print-color-adjust: exact; }
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
